import React, { Component } from 'react'

export default class componentName extends Component {
  render () {
    return (
      <div>
        模块不存在
      </div>
    )
  }
}
